








import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import ChildComponentMixin from '../../common/ts/child-component/ChildComponentMixin';

const SubNavigationItemProps = Vue.extend({
  props: {
    itemText: String,
    itemLink: String,
    editMode: Boolean,
    flyoutUrl: String, // Used in the HeaderFlyout component
  },
});

@Component
export default class SubNavigationItem extends mixins(SubNavigationItemProps, ChildComponentMixin) {
  isActive = false;
  initial = true;

  created () {
    this.initChildComponentMixin(
      'SubNavigationItem',
    );
  }

  get rootClass () {
    return {
      'brandhub-sub-navigation-item': true,
      'brandhub-sub-navigation-item--edit-mode': this.editMode,
      'brandhub-sub-navigation-item--active': this.isActive,
      'brandhub-sub-navigation-item--initial': this.initial,
    };
  }

  onItemClick () {
    this.isActive = true;
    const event = new CustomEvent('subNavClicked', {
      bubbles: true,
      composed: true,
      detail: {
        clickedItem: this,
      },
    });
    this.$el.dispatchEvent(event);
  }
}
